import {makeAutoObservable} from "mobx";

export default class TrackingStore {
    tracking = []
    constructor() {
        makeAutoObservable(this)
    }

    setTrackings(tracking) {
        this.tracking = tracking
    }

}